import { config } from '../utils/constants/api.constants';

const {
  host,
  api_version,
  auditTrail,
  inventoryField,
  inventoryMovementField,
} = config.api.inventory;

export default (api) => {
  const getInventoryFieldHistoryV2 = (inventoryId, params) => {
    const url = host + '/api/audit-log/v2/field/inventory';
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getInventoryFieldAuditHistory = (inventoryId, params) => {
    const url = `${host}${api_version}${auditTrail}${inventoryField}/${inventoryId}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getInventoryMovementFieldAuditHistory = (inventoryId, params) => {
    const url = `${host}${api_version}${auditTrail}${inventoryMovementField}/${inventoryId}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getInventoryFieldAuditHistory,
    getInventoryMovementFieldAuditHistory,
    getInventoryFieldHistoryV2,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
